import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('contactViewConversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('contactViewConversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildContactsViewsConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;

  // Replace the list (do not merge) when we're loading a new filter so we never
  // show contacts from a previous selection (label A when user chose label B).
  const isFirstPage = requestPayload?.page == null || requestPayload.page <= 1;
  const isFilteredView = filterType === 'appliedFilters';
  const hasSidebarFilter =
    (requestPayload?.labels?.length > 0) ||
    requestPayload?.inboxId ||
    requestPayload?.teamId;
  if (isFirstPage && (isFilteredView || hasSidebarFilter)) {
    context.commit(types.CONTACT_EMPTY_ALL_CONVERSATION);
  }

  context.commit(types.CONTACT_SET_ALL_CONVERSATION, conversationList);
  context.dispatch('contactViewConversationStats/set', metaData);
  context.dispatch(
    'contactViewConversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CONTACT_CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: !conversationList.length,
  });
};
